import * as Sentry from '@sentry/browser'
import { envUrl } from '@babylon/babylon-env'

const logException = (e) => {
  const logEx = envUrl('SENTRY_DSN') ? Sentry.captureException : console.error
  logEx(e)
}

export default logException
